<ng-container *ngIf="hasBackgroundImage; else noBackground">
    <section
        class="use-background-image background-image-attributes view-point-background"
        [style.background-image]="backgroundImageUrl">
        <ng-container [ngTemplateOutlet]="dashboardMarkup"></ng-container>
    </section>
</ng-container>
<ng-template #noBackground>
    <ng-container [ngTemplateOutlet]="dashboardMarkup"></ng-container>
</ng-template>
<ng-template #dashboardMarkup>
    <ng-container *ngIf="pane.useTwelveColumnGrid; else defaultDashboard">
        <lm-twelve-column-grid #dashboardViewComponent
           [dashboardPanels]="panels"
           [fromDataView]="m_fromDataView"
           [messageRuleView]="messageRuleView"
           [displayedOnPagePanel]="true"
           (contentModified)="onContentModified($event)"
           (dashboardContentDisplayed)="onDashboardContentDisplayed()"
           (sendContextMessageEvent)="onSendContextMessageEvent($event)"
           (panelTransactionEvent)="onPanelDataUpdated($event)"
        ></lm-twelve-column-grid>
    </ng-container>
    <ng-template #defaultDashboard>
        <lm-dashboard-view #dashboardViewComponent
            [dashboardPanels]="panels"
            [fromDataView]="m_fromDataView"
            [columns]="columns"
            [messageRuleView]="messageRuleView"
            [displayedOnPagePanel]="true"
            (contentModified)="onContentModified($event)"
            (dashboardContentDisplayed)="onDashboardContentDisplayed()"
            (sendContextMessageEvent)="onSendContextMessageEvent($event)"
            (panelTransactionEvent)="onPanelDataUpdated($event)"
        ></lm-dashboard-view>
    </ng-template>
</ng-template>
